import UnbilledOrder from "../../../../types/unbilled-order";

export enum OrderFinishedCargoOrdersUnbilledListParamsLackingBillingType {
  PUB_CARGO_2_RAILY = "PUB_CARGO_2_RAILY",
  PUB_RAILY_2_TAXI = "PUB_RAILY_2_TAXI",
  PRIV_TAXI_2_RAILY = "PRIV_TAXI_2_RAILY",
}

export type OrderFinishedCargoOrdersUnbilledListParams = {
  lackingBillingType?: OrderFinishedCargoOrdersUnbilledListParamsLackingBillingType[];
  order?: UnbilledOrder;
  limit: number;
  offset?: number;
  startTimeSince?: string;
  startTimeTo?: string;
  humanId?: number;
  address?: string;
  startAddress?: string;
  midAddress?: string;
  endAddress?: string;
  passenger?: string;
  dispatch?: string;
  client?: string;
  externalId?: string;
  taxi?: string;
  driver?: string;
  isCancelled?: boolean;
};

export default OrderFinishedCargoOrdersUnbilledListParams;
